import script from "./Banner.vue?vue&type=script&setup=true&lang=js"
export * from "./Banner.vue?vue&type=script&setup=true&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=669eb618&lang=less"

const __exports__ = script;

export default __exports__